import { ItemFractionalType, ProductType } from "../contexts/OrderContext";
import { FractionalType } from "../pages/Food/Product";

export function floatToPrice(value: number) {

    if(value && value !== 0){
        const priceWithoutPontuation = value.toFixed(2).toString().replace(".", ",")
        return "R$ " + putPontuation(priceWithoutPontuation);
    }
    return 'R$ 0,00';
}

export function floatToPriceWithoutSpace(value: number) {

    if(value && value !== 0){
        const priceWithoutPontuation = value.toFixed(2).toString().replace(".", ",")
        return "R$" + putPontuation(priceWithoutPontuation);
    }
    return 'R$0,00';
}

function putPontuation(value: string){
    let [valueInt, cents] = value.split(',');
    let finalValue = ''
    let reverseString = []
    let j = 0;
    for(let i = valueInt.length - 1; i >= 0; i--){
        reverseString[j] = valueInt[i];
        j++
    }
    for(let i = 0; i < reverseString.length; i++){
        if((i+1)% 3 === 0 && i+1 < reverseString.length){
            finalValue += reverseString[i] + '.';
        } else {
            finalValue += reverseString[i]
        }
    }
    let finalStringValue = []
    j = 0;
    for(let i = finalValue.length - 1; i >= 0; i--){
        finalStringValue[j] = finalValue[i];
        j++
    }
    return `${finalStringValue.join('')},${cents}`;

}

export function floatToCents(value: number){
    if(value && parseFloat(value.toString())){
        return parseFloat(value.toFixed(2).toString().replace(".", ""));
    }
    return 0
}

export function centsToFloat(value: number){
    if(value){
        const stringValue = value.toString();
        if(stringValue.includes('.')){
            return value/100
        } else {
            return parseFloat(stringValue.substring(0, stringValue.length-2) + '.' + stringValue.substring(stringValue.length-2, stringValue.length))
        }
    }
    return 0;
}

export function isNumber(n: any) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function floatToPercent(value: number) {

    if(value && value !== 0){
        const priceWithoutPontuation = value.toFixed(2).toString().replace(".", ",")
        return putPontuation(priceWithoutPontuation) +'%' ;
    }
    return '0,00%';
}

export function calculatePriceFractionalToProduct(prod: ProductType) {
    let _price = 0;
    let _quantity = 0;

    if (prod.fractions && prod.fractions.length > 0) {
      if (prod.typeFractional === 'proportional') {
        prod.fractions.forEach((item) => {
            if (item.quantity > 0) {
                _quantity += item.quantity
            }
        })
        if(_quantity === 3){
          let indexItem = 0;
          prod.fractions.forEach((item) => {
            if (item.quantity > 0) {
              indexItem += item.quantity;
              let multiplyItem = Math.trunc((item.quantity / _quantity) * 1000)/1000;
              if(indexItem === _quantity){
                multiplyItem += 0.001
              }
              let value = parseFloat((item.price * multiplyItem).toFixed(2));
              _price += value
            }
          })
        } else {
          prod.fractions.forEach((item) => {
              if (item.quantity > 0) {
                const priceItemCents = item.price * 100;
                let value = parseFloat((priceItemCents / _quantity).toFixed(2));
                _price += (value * item.quantity)/100
              }
          })
        }
      } else if (prod.typeFractional === 'biggest') {
        prod.fractions.forEach((item) => {
          if (item.price > _price)
            _price = item.price
        })
      }
    }
    return _price
}

export function calculatePriceFractionalToFractional(fractional: FractionalType) {
    let _price = 0;
    if (fractional) {
      if (fractional.typePrice === 'proportional') {
        let qtdToDivide = 0;
        fractional.items.forEach((item) => {
          if (item.quantity > 0) {
            qtdToDivide += item.quantity
          }
        })
        if(qtdToDivide === 3){
          let indexItem = 0;
          let newItemFractions:ItemFractionalType[] = [];
          fractional.items.forEach((item) => {
            if(item.quantity > 0){
              for(let i = 0; i < item.quantity; i++){
                const newItem = {...item};
                newItem.quantity = 1
                newItemFractions.push(newItem)
              }
            }
          })
          newItemFractions.forEach((item) => {
            if (item.quantity > 0) {
              indexItem += item.quantity;
              let multiplyItem = Math.trunc((item.quantity / qtdToDivide) * 1000)/1000;
              if(indexItem === qtdToDivide){
                multiplyItem += 0.001
              }
              let value = parseFloat((item.price * multiplyItem).toFixed(2));
              console.log(item.price, multiplyItem, value)
              _price += value
            }
          })
        } else {
          fractional.items.forEach((item) => {
            if (item.quantity > 0) {
              const priceItemCents = item.price * 100;
              let value = parseFloat((priceItemCents / qtdToDivide).toFixed(2));
              _price += (value * item.quantity)/100
            }
          })
        }
      } else if (fractional.typePrice === 'biggest') {
        fractional.items.forEach((item) => {
          if (item.price > _price && item.quantity > 0)
            _price = item.price
        })
      }
    }
    return _price
}